var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._g(_vm._b({staticClass:"select-default",attrs:{"placeholder":_vm.$t('invoiceStrategy.placeholder')}},'el-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.options),function(option){return _c('el-option',{key:option.label,staticClass:"select-default",attrs:{"label":option.label,"value":option.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }